import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import dialogActions from '../features/dialog/actions'
import { selectDialog } from '../features/dialog/selectors'
import storesActions from '../features/stores/actions'
import { pxToRem } from '../libs/style'
import { DeleteDocumentType } from '../model/dialog'
import { useTeloDispatch, useTeloSelector } from '../store'
import Button from '../styleguide/buttons/Button'
import DialogActions from '../styleguide/dialog/DialogActions'
import DialogContent from '../styleguide/dialog/DialogContent'
import DialogContentText from '../styleguide/dialog/DialogContentText'

const DialogContentTextStyled = styled(DialogContentText)`
	min-width: ${pxToRem(299)}rem;
`

const isDeleteDocumentDialog = (dialog: any): dialog is DeleteDocumentType =>
	'document' in dialog &&
	dialog.type === 'deleteDocument' &&
	'storeId' in dialog

const DeleteDocumentDialog = () => {
	const { t } = useTranslation()
	const dispatch = useTeloDispatch()
	const dialog = useTeloSelector(selectDialog)

	return !isDeleteDocumentDialog(dialog) ? null : (
		<>
			<DialogContent>
				<DialogContentTextStyled>
					{t('stores.documents.confirmDelete', {
						name: dialog.document.name,
						storeName: dialog.storeName,
					})}
				</DialogContentTextStyled>
			</DialogContent>
			<DialogActions>
				<Button
					onClick={() => dispatch(dialogActions.closeDialog())}
					variant="outlined"
				>
					{t('app.cancel')}
				</Button>
				<Button
					onClick={() => {
						dispatch(
							storesActions.deleteDocumentAction(
								dialog.storeId,
								dialog.document._id,
							),
						).finally(() => dispatch(dialogActions.closeDialog()))
					}}
					autoFocus
					variant="contained"
				>
					{t('app.delete')}
				</Button>
			</DialogActions>
		</>
	)
}

export default DeleteDocumentDialog
